import { jobConfigurationActions } from '../../reducers/jobConfiguration/jobConfiguration';
import { getRequest, postRequest } from '../../../shared/axiosRequest';
import { API_PATHS } from '../../../shared/apiConsts';
import { camelCaseToSpacedString } from '../../../shared/utility';

export const getProjectFeatures = () => {
  return async dispatch => {
    try {
      const response = await getRequest('API....');
      const data = await response.json();
      dispatch(jobConfigurationActions.setProjectFeatures(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getMainProjects = () => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_PROJECTS);
      const data = { mainProjects: response.map(obj => obj.ProjectGroup) };
      dispatch(jobConfigurationActions.setProjectSelectionMainProjects(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSubProjects = mainProject => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_SUB_PROJECTS, {
        mainProject,
      });
      const data = { subProjects: response };
      dispatch(jobConfigurationActions.setProjectSelectionSubProjects(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getModelSelectionFilters = project => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_RELEASE_FILTERS, {
        project,
      });
      const data = {
        filters: response.map(row => ({
          ...row,
          displayText: camelCaseToSpacedString(row.filterField),
        })),
      };
      dispatch(jobConfigurationActions.setModelSelectionFilters(data));
    } catch (error) {
      console.error(error);
    }
  };
};

const parseFilters = filters => {
  const includeArray = [];
  const excludeArray = [];

  // Iterate over the keys of the dynamic object
  for (const key in filters) {
    const attributes = filters[key];

    // Iterate over the attributes of each key
    for (const attribute in attributes) {
      if (attributes[attribute] === 'include') {
        includeArray.push(attribute);
      } else if (attributes[attribute] === 'exclude') {
        excludeArray.push(attribute);
      }
    }
  }
  return {
    includeFilters: includeArray.join(','),
    excludeFilters: excludeArray.join(','),
  };
};

export const getModelSelectionReleases = (project, filters) => {
  return async dispatch => {
    try {
      const parsedFilters = parseFilters(filters);
      const response = await getRequest(API_PATHS.GET_RELEASES, {
        project,
        ...parsedFilters,
      });
      const data = {
        releases: response.map(obj => ({ ...obj, id: obj.ReleaseId })),
      };
      dispatch(jobConfigurationActions.setModelSelectionReleases(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setSelectedRelease = selectedRelease => {
  return async dispatch => {
    try {
      const data = { selectedRelease: selectedRelease };
      dispatch(jobConfigurationActions.setModelSelectionSelectedRelease(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getTargets = (project, release, filters) => {
  return async dispatch => {
    try {
      const parsedFilters = parseFilters(filters);
      const response = await getRequest(API_PATHS.GET_TARGETS, {
        project,
        release,
        ...parsedFilters,
      });
      const data = {
        targets: response.map(obj => ({ ...obj, id: obj.TargetId })),
      };
      dispatch(jobConfigurationActions.setTargetSelectionTargets(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setSelectedTarget = selectedTarget => {
  return async dispatch => {
    try {
      const data = { selectedTarget: selectedTarget };
      dispatch(jobConfigurationActions.setTargetSelectionSelectedTarget(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getTestConfigDynamicFields = project => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_TEST_FIELDS, { project });
      const data = { fields: response };

      dispatch(jobConfigurationActions.setTestConfigDynamicFields(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setTestFieldValue = data => {
  return async dispatch => {
    try {
      dispatch(jobConfigurationActions.setTestConfigFieldValue(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setTestFieldError = data => {
  return async dispatch => {
    try {
      dispatch(jobConfigurationActions.setTestConfigFieldError(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setTestConfigDynamicFieldValue = data => {
  return async dispatch => {
    try {
      dispatch(jobConfigurationActions.setTestConfigDynamicFieldValue(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getTestConfigFuses = targetId => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_FUSES, { targetId });
      const data = {
        fuses: response,
      };

      dispatch(jobConfigurationActions.setTestConfigFuses(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getTestConfigStraps = targetId => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_STRAPS, { targetId });
      const data = {
        straps: response,
      };

      dispatch(jobConfigurationActions.setTestConfigStraps(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateFuses = update => {
  return async dispatch => {
    try {
      dispatch(jobConfigurationActions.updateFuses(update));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setTestConfigFieldValues = fieldValues => {
  return async dispatch => {
    try {
      dispatch(jobConfigurationActions.setTestConfigFieldValues(fieldValues));
    } catch (error) {
      console.error(error);
    }
  };
};

export const downloadListFile = (
  fields,
  dynamicFields,
  fuses,
  straps,
  targetId
) => {
  return async () => {
    try {
      const { fileContent } = await postRequest(API_PATHS.GET_LIST_FILE, {
        fields,
        dynamicFields,
        fuses,
        straps,
        targetId,
      });
      return fileContent;
    } catch (error) {
      console.error(error);
    }
  };
};
